<div
  class="flex items-center bg-white rounded-lg"
  *transloco="let t; scope: 'featureAiAssistant'; prefix: 'featureAiAssistant'"
>
  <p-button
    [text]="true"
    [attr.aria-label]="t('toolbar.undo')"
    [pTooltip]="t('toolbar.undo')"
    tooltipPosition="bottom"
    [showDelay]="500"
    styleClass="bd-toolbar-button bd-round-left"
    [disabled]="!canUndoUserPrompt()"
    (onClick)="onUndoUserPrompt.emit()"
    data-id="undo-user-prompt-button"
    ><i class="ui-undo pr-1"></i>
  </p-button>
  <p-button
    [text]="true"
    [attr.aria-label]="t('toolbar.redo')"
    [pTooltip]="t('toolbar.redo')"
    tooltipPosition="bottom"
    [showDelay]="500"
    styleClass="bd-toolbar-button"
    [disabled]="!canRedoUserPrompt()"
    (onClick)="onRedoUserPrompt.emit()"
    data-id="redo-user-prompt-button"
    ><i class="ui-redo pr-1"></i>
  </p-button>
  <p-divider layout="vertical"></p-divider>
  <p-button
    [text]="true"
    [attr.aria-label]="t('toolbar.discard')"
    [pTooltip]="t('toolbar.discard')"
    tooltipPosition="bottom"
    [showDelay]="500"
    styleClass="bd-toolbar-button bd-danger"
    data-id="close-suggestion-button"
    (onClick)="onCloseSuggestion.emit()"
    ><i class="ui-delete pr-1"></i>
  </p-button>
  @if (canSaveToWorkspace()) {
    <p-divider layout="vertical"></p-divider>
    <p-button
      class="px-2"
      [outlined]="true"
      styleClass="bd-neutral bd-size-small"
      data-id="assistant-save-to-workspace-button"
      (onClick)="onSaveToWorkspace.emit()"
      [label]="t('toolbar.saveButton')"
    >
    </p-button>
  }
</div>
